/**
 * 選出回数 (selectionCount) を 5 段階の tier にマップするロジック。
 * 百名店の選出回数は最大 9 回なので、2 回ごとに区切って 5 ティアに分ける:
 *   t1: 1 回         (新規・未常連)
 *   t2: 2-3 回       (リピート選出)
 *   t3: 4-5 回       (中堅)
 *   t4: 6-7 回       (高位)
 *   t5: 8-9 回       (最高位 / プレミアム)
 *
 * カラースキームは「クール (sky) → 温色 (amber) → ホット (rose)」へ熱量が
 * 上がっていくグラデーション。StoreMarker / StoreList で同じ tier 関数と
 * クラステーブルを参照し、見た目を一貫させる。
 */

export type Tier = "t1" | "t2" | "t3" | "t4" | "t5";

export function getTier(count: number): Tier {
  if (count >= 8) return "t5";
  if (count >= 6) return "t4";
  if (count >= 4) return "t3";
  if (count >= 2) return "t2";
  return "t1";
}

/** マップピン (StoreMarker) の chip 本体クラス。 */
export const TIER_CHIP_CLASS: Record<Tier, string> = {
  t1: "border-white/30 bg-slate-900/95 text-slate-100",
  t2: "border-sky-200/70 bg-gradient-to-b from-sky-500 to-sky-600 text-white",
  t3: "border-emerald-200/70 bg-gradient-to-b from-emerald-500 to-emerald-600 text-white",
  t4: "border-amber-200/80 bg-gradient-to-b from-amber-400 to-amber-500 text-slate-900",
  t5: "border-rose-200/80 bg-gradient-to-b from-rose-500 via-rose-600 to-amber-600 text-white",
};

/** 上記 chip の中に表示する選出回数のミニバッジ。 */
export const TIER_INNER_BADGE_CLASS: Record<Tier, string> = {
  t1: "bg-white/15 text-slate-100",
  t2: "bg-white/25 text-white",
  t3: "bg-white/25 text-white",
  t4: "bg-slate-900/25 text-slate-900",
  t5: "bg-white/25 text-white",
};

/** chip 下のポインタ (▼形)。 */
export const TIER_POINTER_CLASS: Record<Tier, string> = {
  t1: "bg-slate-900",
  t2: "bg-sky-600",
  t3: "bg-emerald-600",
  t4: "bg-amber-500",
  t5: "bg-rose-600",
};

/** StoreList の "N回" バッジ。 */
export const TIER_LIST_BADGE_CLASS: Record<Tier, string> = {
  t1: "bg-slate-800 text-slate-300 ring-1 ring-inset ring-white/10",
  t2: "bg-gradient-to-br from-sky-500 to-sky-600 text-white",
  t3: "bg-gradient-to-br from-emerald-500 to-emerald-600 text-white",
  t4: "bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900",
  t5: "bg-gradient-to-br from-rose-500 via-rose-600 to-amber-500 text-white",
};
